import React from "react";
import { NavLink } from "react-router-dom";
import queryString from 'query-string'
import "./Course_details.scss";
import OracleSQL from "../courseData/Oracle_SQL";
import OracleDBAL1 from "../courseData/OracleDBA_L1";
import OracleDBAL2 from "../courseData/OracleDBA_L2";
import Goldengate from "../courseData/Goldengate";
import DataWarehouse from "../courseData/Data_Warehouse";
import RHCSA from "../courseData/RHCSA";
import RHCE from "../courseData/RHCE";
import DevOps from "../courseData/DevOps";
import Ansible from "../courseData/Ansible";
import OpenStack from "../courseData/OpenStack";
import ServerHardening from "../courseData/ServerHardening";
import Virtualization from "../courseData/Virtualization";
import PLSQL from "../courseData/PLSQL";
import Angular from "../courseData/Angular";
import Python from "../courseData/Python";
import CPP from "../courseData/CPP";
import CoreJava from "../courseData/CoreJava";
import AdvanceJava from "../courseData/AdvanceJava";
import C from "../courseData/C";

function Course_details({location}) {
  function scrollPage() {
    window.scrollTo({
      top: 0
    });
  }
  scrollPage();

  let content = <div></div>;
  let url = queryString.parse(location.search);

  if (url.content === "Oracle_SQL") {
    content = (
      <div>
        <OracleSQL />
      </div>
    );
  }
  if (url.content === "OracleDBA_L1") {
    content = (
      <div>
        <OracleDBAL1 />
      </div>
    );
  }
  if (url.content === "OracleDBA_L2") {
    content = (
      <div>
        <OracleDBAL2 />
      </div>
    );
  }
  if (url.content === "goldengate") {
    content = (
      <div>
        <Goldengate/>
      </div>
    );
  }

  if (url.content === "Data_Warehouse") {
    content = (
      <div>
        <DataWarehouse/>
      </div>
    );
  }

  if (url.content === "RHCSA") {
    content = (
      <div>
        <RHCSA/>
      </div>
    );
  }

  if (url.content === "RHCE") {
    content = (
      <div>
        <RHCE/>
      </div>
    );
  }

  if (url.content === "DevOps") {
    content = (
      <div>
        <DevOps/>
      </div>
    );
  }
    if (url.content === "Ansible") {
    content = (
      <div>
        <Ansible/>
      </div>
    );
  }

  if (url.content === "OpenStack") {
    content = (
      <div>
        <OpenStack/>
      </div>
    );
  }

  
  if (url.content === "ServerHardening") {
    content = (
      <div>
        <ServerHardening/>
      </div>
    );
  }
  if (url.content === "Virtualization") {
    content = (
      <div>
        <Virtualization/>
      </div>
    );
  }
  if (url.content === "PLSQL") {
    content = (
      <div>
        <PLSQL/>
      </div>
    );
  }
  if (url.content === "Angular") {
    content = (
      <div>
        <Angular/>
      </div>
    );
  }

  if (url.content === "Python") {
    content = (
      <div>
        <Python/>
      </div>
    );
  }

  if (url.content === "CPP") {
    content = (
      <div>
        <CPP/>
      </div>
    );
  }
  if (url.content === "CoreJava") {
    content = (
      <div>
        <CoreJava/>
      </div>
    );
  }
  if (url.content === "AdvanceJava") {
    content = (
      <div>
        <AdvanceJava/>
      </div>
    );
  }
  if (url.content === "C") {
    content = (
      <div>
        <C/>
      </div>
    );
  }

  return (
    <section className="course_details">
      <div className="container">
        <div className="row">
          <div className="courseDetails">
            {content}
            <br/>
            <NavLink to="/contact" id="courseButton" activeClassName="active">
              Contact
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );

  // }
}

export default Course_details;
